export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/reach/locales/${locale}.json`);

export default getModuleMessages;
